import request from './request';
import URLS from '../configurations/urls';
import Api from './Api';


class UserApi extends Api{

    static getUserPermissions(params = {}){
        let options =  Object.assign({}, Api.BASE_HTTP_OPTIONS);
        options.url += `${URLS.USER_API_USER_PERMISSIONS}`;
        options.params = params;
        return request.get(options);
    }
}

export default UserApi;


// WEBPACK FOOTER //
// ./src/api/UserApi.js